<div class="container">
    <div class="section-title">
        <h2>{{'main_title_contact' | translate}}</h2>
        <div class="bar"></div>
        <!-- <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incidiunt  labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida.</p> -->
    </div>

    <div class="row align-items-center">
        <div class="col-lg-6">
            <div class="contact-form">
                <form id="contactForm">
                    <div class="row">
                        <div class="col-lg-6 col-md-6">
                            <div class="form-group">
                                <input [(ngModel)]="contact.name" type="text" name="name" id="name" class="form-control" required placeholder="{{'left_contact_name' | translate}}">
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6">
                            <div class="form-group">
                                <input [(ngModel)]="contact.phoneNumber" type="text" name="phone_number" id="phone_number" required class="form-control" placeholder="{{'left_contact_phone' | translate}}">
                            </div>
                        </div>
                        <div class="col-lg-12 col-md-12">
                            <div class="form-group">
                                <input [(ngModel)]="contact.email" type="email" name="email" id="email" class="form-control" required placeholder="Email">
                            </div>
                        </div>


                        <!-- <div class="col-lg-6 col-md-6">
                            <div class="form-group">
                                <input type="text" name="phone_number" id="phone_number" required class="form-control" placeholder="{{'left_contact_phone' | translate}}">
                            </div>
                        </div> -->

                        <!-- <div class="col-lg-6 col-md-6">
                            <div class="form-group">
                                <input type="text" name="msg_subject" id="msg_subject" class="form-control" required placeholder="{{'left_contact_problem' | translate}}">
                            </div>
                        </div>

                        <div class="col-lg-12 col-md-12">
                            <div class="form-group">
                                <textarea name="message" class="form-control" id="message" cols="30" rows="6" required placeholder="{{'left_contact_content' | translate}}"></textarea>
                            </div>
                        </div> -->
                        <div *ngIf="msgNull == 'no-contact' " style="color: #007bff">
                            {{'inputFull' | translate}}
                        </div>
                        <div class="col-lg-12 col-md-12">
                            <div class="send-btn">
                                <button type="submit" (click)="createContact()" class="default-btn">{{'btn_sendmsg' | translate}} <span></span></button>
                            </div>
                        </div>

                    </div>
                </form>
            </div>
        </div>

        <div class="col-lg-6">
            <div class="contact-info">
                <div class="contact-info-content">
                    <h3>{{'right_contact_1' | translate}}</h3>
                    <h2>
                        <a href="tel:+84-090-252-7421">+84 090-252-7421</a>
                        <span>{{'right_contact_2' | translate}}</span>
                        <a href="hello@citydiscovery.com">hello@citydiscovery.com</a>
                    </h2>
                    <ul class="social">
                        <li><a href="#" target="_blank"><i class="fab fa-facebook-f"><fa-icon [icon]="faFacebookF"></fa-icon></i></a></li>
                        <li><a href="#" target="_blank"><i class="fab fa-twitter"><fa-icon [icon]="faTwitter"></fa-icon></i></a></li>
                        <li><a href="#" target="_blank"><i class="fab fa-linkedin-in"><fa-icon [icon]="faLinkedinIn"></fa-icon></i></a></li>
                        <li><a href="#" target="_blank"><i class="fab fa-instagram"><fa-icon [icon]="faInstagram"></fa-icon></i></a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
